import React, { useState, useEffect } from 'react';
import './Study.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import parse from 'html-react-parser';
import Spinner from '../Spinner/Spinner';
import { Button } from 'react-bootstrap';
import { withRouter } from "react-router";
import { post } from '../../app/shared/http';
import { withAuth } from "../../app/util/HOC";
import StudyCenterHeader from './StudyCenterHeader';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import { usePagination } from '@material-ui/lab/Pagination';
let checkans = false;
var userVORole;
const useStyles = makeStyles({
    ul: {
        margin: 0,
        padding: 0,
        display: 'flex',
        listStyle: 'none',
    },
});
export function StudyMCQStudent(props) {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [bookVO, setBookVO] = useState(JSON.parse(localStorage.getItem('bookVO')));
    const [answerOptionIndex, setAnswerOptionIndex] = useState('');
    const [totalQuestionCount, setTotalQuestionCount] = useState(0);
    const [questionBankVOList, setQuestionBankVOList] = useState(null);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [systemGradedValue, setSystemGradedValue] = useState("N/A");
    const [loName, setLoName] = useState("");
    const [isloading, setisLoading] = useState(false);
    const [btnFlagText, setbtnFlagText] = useState("Flag For Later");
    const [practicebtn, setpracticebtn] = useState(false);
    const [correctbtn, setcorrectbtn] = useState(false);
    const [incorrectbtn, setincorrectbtn] = useState(false);
    const classes = useStyles();
    useEffect(() => {
        async function fetchQuestions() {
            userVORole = userVO.userRole;
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "userRoleId": userVO.userRoleId,
                    "userActivityVO": {
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingTo": "BOOKSHELF",
                        "pageNavigatingFrom": "BOOKSHELF",
                    },
                    "sessionVO": {
                        "appType": "web",
                        "deviceMacId": "",
                        "keepMeLoggedInFlag": keepMeLogIn,
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                    },
                },
                "bookVO": {
                    "bookISBN": props.match.params.isbn
                },
                "questionVO": {
                    "classId": -999,
                    "questionType": "multichoice",
                    "bookISBN": props.match.params.isbn,
                    "chapterId": props.match.params.chapterid,
                    "learningObjectId": props.match.params.loid,
                    "limit": localStorage.getItem('sumOfAllQuestions')
                }
            }
            const requestOptions1 = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(reqData)
            };
            setisLoading(true);
            fetch(localStorage.getItem('ENV') + "/assessmentRetrievalService/getQuestionForStudyCenterLearnRv", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        if (data.status === "true") {
                            var loName = data.learningObjName;
                            if (data.assessmentVO && data.assessmentVO.questionBankVOList) {
                                if (data.assessmentVO.questionBankVOList) {
                                    data.bookVO.chapterId = props.match.params.chapterid
                                    var flag = 0;
                                    data.assessmentVO.questionBankVOList = Array.isArray(data.assessmentVO.questionBankVOList) ? data.assessmentVO.questionBankVOList :
                                        [data.assessmentVO.questionBankVOList]
                                    if (data.assessmentVO.questionBankVOList[0].questionResponseVO.status == "correct") {
                                        setpracticebtn(false);
                                        setincorrectbtn(false);
                                        setcorrectbtn(true);
                                    }
                                    else if (data.assessmentVO.questionBankVOList[0].questionResponseVO.status == "incorrect") {
                                        setpracticebtn(false);
                                        setincorrectbtn(true);
                                        setcorrectbtn(false);
                                    }
                                    else {
                                        setpracticebtn(true);
                                        setincorrectbtn(false);
                                        setcorrectbtn(false);
                                    }
                                    for (var i = 0; i < data.assessmentVO.questionBankVOList.length; i++) {
                                        if (data.assessmentVO.questionBankVOList[i].currentQuestionFlag == "1"
                                            && data.assessmentVO.questionBankVOList[i].questionResponseVO.status != "not attempted") {
                                            checkans = true;
                                        }
                                        if (data.assessmentVO.questionBankVOList[i].questionResponseVO.status === "not attempted") {
                                            flag = 1;
                                            setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                                            setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                                            setCurrentQuestion(data.assessmentVO.questionBankVOList[i]);
                                            setBookVO(data.bookVO);
                                            setLoName(loName);
                                            setSystemGradedValue(getSystemGrade(data.assessmentVO.questionBankVOList[i]));
                                            updateCurrentQuestionBtn(i + 1);
                                            break;
                                        }
                                    }
                                    if (flag === 0) {
                                        setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                                        setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                                        setCurrentQuestion(data.assessmentVO.questionBankVOList[0]);
                                        setBookVO(data.bookVO);
                                        setLoName(loName);
                                        setSystemGradedValue(getSystemGrade(data.assessmentVO.questionBankVOList[0]));
                                        updateCurrentQuestionBtn(1);
                                        setisLoading(false);
                                    }
                                } else
                                    setLoName(loName);
                                setisLoading(false);
                            } else
                                setLoName(loName);
                            setisLoading(false);
                        } else {
                            if (data.wkErrorCode) {
                                handleException(data);
                            }
                        }
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                    setisLoading(false);
                });
        }
        fetchQuestions();
    }, []);
    const handleChange = (event) => {
        setAnswerOptionIndex(event.target.value);
    }
    const getQuestion = (e) => {
        if(parseInt(totalQuestionCount - 1) === parseInt(e.target.getAttribute("arrayIndex"))){
            document.getElementById(`btnQuestion_${parseInt(currentQuestion.questionNumber) + 1}`).focus();
         }
        if (e.target.getAttribute("arrayIndex") !== undefined &&
            questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]) {
            setCurrentQuestion(questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]);
            setSystemGradedValue(getSystemGrade(questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]));
            /*CC-5522 HS */
            var cques = questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]
            setbtnFlagText(cques.questionResponseVO.flagged === "false" ? "Flag For Later" : "Flagged");
            updateCurrentQuestionBtn(parseInt(e.target.getAttribute("arrayIndex")) + 1, e.currentTarget.innerText);
            if (questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "correct") {
                setpracticebtn(false);
                setincorrectbtn(false);
                setcorrectbtn(true);
            }
            else if (questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "incorrect") {
                setpracticebtn(false);
                setincorrectbtn(true);
                setcorrectbtn(false);
            }
            else {
                setpracticebtn(true);
                setincorrectbtn(false);
                setcorrectbtn(false);
            }
            if (questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "correct"
                || questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "incorrect"
                || questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))].questionResponseVO.status == "partial") {
                checkans = true;
            }
            else {
                checkans = false;
            }
        }
        if (document.getElementById("btnQuestion_" + parseInt(e.target.getAttribute("arrayIndex")) + 1))
            document.getElementById("btnQuestion_" + parseInt(e.target.getAttribute("arrayIndex")) + 1).classList.remove("active-question-btn")
    }
    const updateCurrentQuestionBtn = (questionNumber, btnName) => {
        setAnswerOptionIndex("");
        document.querySelectorAll('.questionNumberBtn').forEach(x => {
            x.classList.remove("active-question-btn");
        });
        if (document.getElementById("btnQuestion_" + questionNumber - 1)) {
            document.getElementById("btnQuestion_" + questionNumber - 1).classList.remove("active-question-btn");
            document.getElementById("btnQuestion_" + questionNumber - 1).style.border = "inherit";
        }
        if (document.getElementById("btnQuestion_" + questionNumber + 1)) {
            document.getElementById("btnQuestion_" + questionNumber + 1).classList.remove("active-question-btn");
            document.getElementById("btnQuestion_" + questionNumber + 1).style.border = "inherit";
        }
        if (btnName === "Skip" || btnName === "Next") {
            if (document.getElementById("btnQuestion_" + questionNumber))
                document.getElementById("btnQuestion_" + questionNumber).classList.add("active-question-btn")
            document.querySelectorAll('.questionNumberBtn').forEach(x => x.style.border = "inherit")
        }
    }
    const getSystemGrade = (currQuestion) => {
        var systemGradeValue = "NA"
        if (currQuestion.questionResponseVO.attemptedAnswerVOList) {
            var selectedOptionArray = currQuestion.questionResponseVO.attemptedAnswerVOList.optionNumber.split(",")
            if (selectedOptionArray.length > 0) {
                var mdlAns = [], result = [];
                var mldOptions = currQuestion.questionVO.answerVOList;
                // frame the moodle correct options
                for (var i = 0; i < mldOptions.length; i++) {
                    if (mldOptions[i].fraction === "1.0") {
                        mdlAns.push(i + 1);
                    }
                }
                for (var i = 0; i < selectedOptionArray.length; i++) {
                    for (var j = 0; j < mdlAns.length; j++) {
                        if (parseInt(selectedOptionArray[i]) === parseInt(mdlAns[j])) {
                            result.push(selectedOptionArray[i])
                        }
                    }
                }
                var grade = "0";
                if (result.length === 0)
                    systemGradeValue = "incorrect"
                else if (result.length < mdlAns.length)
                    systemGradeValue = "partial"
                else if (result.length === mdlAns.length)
                    systemGradeValue = "correct"
            }
            return systemGradeValue
        }
    }
    const submitAnswer = (e) => {
        var inputs = document.querySelectorAll('.answerOption');
        var selectedOptionArray = [], responseTextArray = [];
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].checked === true) {
                checkans = true;
                selectedOptionArray.push(inputs[i].value)
                var label = document.getElementById("answerLabel_" + inputs[i].value)
                responseTextArray.push(label.textContent)
            }
        }
        if (selectedOptionArray.length > 0) {
            var selectedOptions = selectedOptionArray.join()
            var responseText = responseTextArray.join()
            var mdlAns = [], result = [];
            var mldOptions = currentQuestion.questionVO.answerVOList;
            // frame the moodle correct options
            for (var i = 0; i < mldOptions.length; i++) {
                if (mldOptions[i].fraction === "1.0") {
                    mdlAns.push(i + 1);
                }
            }
            for (var i = 0; i < selectedOptionArray.length; i++) {
                for (var j = 0; j < mdlAns.length; j++) {
                    if (parseInt(selectedOptionArray[i]) === parseInt(mdlAns[j])) {
                        result.push(selectedOptionArray[i])
                    }
                }
            }
            var grade = "0";
            if (result.length === 0)
                grade = "0"
            else if (result.length < mdlAns.length)
                grade = "2";
            else if (result.length === mdlAns.length)
                grade = "1";
            var correctOptions = mdlAns.join()
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userActivityVO": {
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "BOOKSHELF",
                        "pageNavigatingTo": "BOOKSHELF",
                    },
                    sessionVO: {
                        "appType": "web",
                        "browserName": localStorage.getItem('browserName'),
                        "deviceMacId": "",
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "keepMeLoggedInFlag": keepMeLogIn,
                        "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                    },
                    "userRole": userVO.userRole,
                    "userRoleId": userVO.userRoleId,
                },
                "assessmentVO": {
                    "questionVO": {
                        "grade": grade,
                        "questionType": "multichoice",
                        "optionNumber": selectedOptions,
                        "chapterId": props.match.params.chapterid,
                        "learningObjectId": props.match.params.loid,
                        "questionNumber": currentQuestion.questionNumber,
                        "answerVOList": [{ "responseText": responseText }],
                        "questionId": currentQuestion.questionVO.questionId,
                    }
                }
            }
            if (currentQuestion.questionVO.contentType === "Multianswer") {
                reqData.assessmentVO.questionVO.multiAnswer = "1"
            }
            const requestOptions1 = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(reqData)
            };
            fetch(localStorage.getItem('ENV') + "/manageAssessmentService/saveQuestionResponse", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        if (data.status === "true") {
                            var currQuestion = currentQuestion
                            if (grade === "0") {
                                currQuestion.questionResponseVO.status = "incorrect";
                                setpracticebtn(false);
                                setincorrectbtn(true);
                                setcorrectbtn(false);
                            }
                            else if (grade === "1") {
                                currQuestion.questionResponseVO.status = "correct";
                                setpracticebtn(false);
                                setincorrectbtn(false);
                                setcorrectbtn(true);
                            }
                            else if (grade === "2") {
                                currQuestion.questionResponseVO.status = "partial";
                                setpracticebtn(true);
                                setincorrectbtn(false);
                                setcorrectbtn(false);
                            }
                            currQuestion.questionResponseVO.attemptedAnswerVOList = {}
                            currQuestion.questionResponseVO.attemptedAnswerVOList.optionNumber = selectedOptions
                            setCurrentQuestion(currQuestion);
                            setSystemGradedValue(getSystemGrade(currQuestion));
                        } else if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                });
        }
    }
    const navigateToChapterInsights = (e) => {
        if (userVORole === "Professor") {
            props.history.push(`/study/${props.match.params.isbn}/${props.match.params.chapterid}`);
        }
    }
    const navigateToStudyDashboard = (e) => {
        if (userVORole === "Professor") {
            props.history.push(`/study/${props.match.params.isbn}`);
        }
        else if (userVORole === "Student") {
            props.history.push(`/study/${props.match.params.isbn}/${props.match.params.chapterid}`);
        }
    }
    const flagQuestion = (e) => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "BOOKSHELF",
                    "pageNavigatingTo": "BOOKSHELF",
                },
                sessionVO: {
                    "appType": "web",
                    "browserName": localStorage.getItem('browserName'),
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                },
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
            },
            "assessmentVO": {
                "questionVO": {
                    "questionType": "multichoice",
                    "questionId": currentQuestion.questionVO.questionId,
                    "flagValue": e.target.getAttribute("flagValue") === "true" ? "0" : "1"
                }
            }
        }
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        };
        fetch(localStorage.getItem('ENV') + "/manageAssessmentService/saveFlagUnflagStatus", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data) {
                    if (data.status === "true") {
                        var currQuestion = currentQuestion;
                        currQuestion.questionResponseVO.flagged = e.target.getAttribute("flagValue") === "true" ? "false" : "true";
                        setCurrentQuestion(currQuestion);
                        setbtnFlagText(currentQuestion.questionResponseVO.flagged === "false" ? "Flag For Later" : "Flagged");
                        setSystemGradedValue(getSystemGrade(currQuestion));
                    } else {
                        if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const updateGrade = (e) => {
        let grade = 0;
        if (e.target.getAttribute("myKnowledge") === "correct") {
            grade = 1;
            setpracticebtn(false);
            setincorrectbtn(false);
            setcorrectbtn(true);
        }
        else if (e.target.getAttribute("myKnowledge") === "incorrect") {
            grade = 0;
            setpracticebtn(false);
            setincorrectbtn(true);
            setcorrectbtn(false);
        }
        else if (e.target.getAttribute("myKnowledge") === "partial") {
            grade = 2;
            setpracticebtn(true);
            setincorrectbtn(false);
            setcorrectbtn(false);
        }
        var currQuestion = currentQuestion
        var selectedOption = "";
        if (currQuestion.questionResponseVO.attemptedAnswerVOList)
            selectedOption = currQuestion.questionResponseVO.attemptedAnswerVOList.optionNumber
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "BOOKSHELF",
                    "pageNavigatingTo": "BOOKSHELF",
                },
                sessionVO: {
                    "appType": "web",
                    "browserName": localStorage.getItem('browserName'),
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                },
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
            },
            "assessmentVO": {
                "questionVO": {
                    "grade": grade,
                    "questionType": "multichoice",
                    "optionNumber": selectedOption,
                    "chapterId": props.match.params.chapterid,
                    "learningObjectId": props.match.params.loid,
                    "questionNumber": currentQuestion.questionNumber,
                    "questionId": currentQuestion.questionVO.questionId,
                    "answerVOList": [{ "responseText": "MYKNOWLEDGE_GRADE_UPDATE" }],
                }
            }
        }
        if (currentQuestion.questionVO.contentType === "Multianswer") {
            reqData.assessmentVO.questionVO.multiAnswer = "1"
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/manageAssessmentService/saveQuestionResponse", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data) {
                        let btn = document.getElementById("btnQuestion_" + currentQuestion.questionNumber)
                        if (grade === 0) {
                            currQuestion.questionResponseVO.status = "incorrect"
                            btn.className = "numberBox redBgColor";
                        }
                        else if (grade === 1) {
                            currQuestion.questionResponseVO.status = "correct"
                            btn.className = "numberBox greenBgColor";
                        }
                        else if (grade === 2) {
                            currQuestion.questionResponseVO.status = "partial"
                            btn.className = "numberBox blueBgColor";
                        }
                        setCurrentQuestion(currQuestion);
                        setSystemGradedValue(getSystemGrade(currQuestion));
                    }
                } else {
                    if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            });
    }
    const selectedOptions = (selectedOptions) => {
        var options = [];
        selectedOptions.map(option => options.push(String.fromCharCode(65 + option)))
        return options.join()
    }
    const correctAnswers = (options) => {
        let correctOptions = []
        for (var i = 0, j = 1; i < options.length; i++, j++) {
            if (options[i].fraction === "1.0") {
                correctOptions.push(String.fromCharCode(65 + i))
            }
        };
        return correctOptions.join();
    }
    const getAnswerIcon = (attemptedAnswerVOList, index, answerOption, contentType) => {
        if (attemptedAnswerVOList !== undefined && attemptedAnswerVOList !== null) {
            var returnIcon = [];
            var attemptedList = attemptedAnswerVOList.optionNumber.split(",");
            if (answerOption.fraction === "1.0") {
                returnIcon.push(
                    <span>
                        <i className="far fa-check-circle" role='button' aria-label='Correct Answer' style={{ marginTop: '.2rem', color: '#85BC20', marginLeft: '-16.6px', marginRight: '4px', cursor: 'default' }}></i>
                    </span>
                )
            }
            for (var i = 0, j = 1; i < attemptedList.length; i++, j++) {
                if (parseInt(attemptedList[i]) === index) {
                    if (answerOption.fraction === "1.0") {
                        if (contentType !== "Multianswer") {
                            returnIcon.push(
                                <span>
                                    <input type="radio" role="radio" aria-label={answerOption.answer && parse(answerOption.answer)} disabled="true" defaultChecked className="answerOption" />
                                </span>
                            )
                        } else {
                            returnIcon.push(
                                <span>
                                    <input type="checkbox" role="checkbox" aria-label={answerOption.answer && parse(answerOption.answer)} disabled="true" defaultChecked className="answerOption" />
                                </span>
                            )
                        }
                    } else {
                        if (contentType !== "Multianswer")
                            returnIcon.push(
                                <span>
                                    <i className="far fa-times-circle" role='button' aria-label='Incorrect Answer' style={{ color: '#E5202E', marginLeft: '-16.6px', marginRight: '4px', cursor: 'default' }} ></i>
                                    <input type="radio" role="radio" aria-label={answerOption.answer && parse(answerOption.answer)} disabled="true" defaultChecked className="answerOption" />
                                </span>
                            )
                        else
                            returnIcon.push(
                                <span className="float-left">
                                    <i className="far fa-times-circle" role='button' aria-label='Incorrect Answer' style={{ color: '#E5202E', marginLeft: '-16.6px', marginRight: '4px', cursor: 'default' }}></i>
                                    <input type="checkbox" role="checkbox" aria-label={answerOption.answer && parse(answerOption.answer)} disabled="true" defaultChecked className="answerOption" />
                                </span>
                            )
                    }
                } else {
                    if (contentType !== "Multianswer")
                        returnIcon.push(
                            <span>
                                <input type="radio" role="radio" aria-label={answerOption.answer && parse(answerOption.answer)} disabled="true" className="answerOption" />
                            </span>
                        )
                    else
                        returnIcon.push(
                            <span>
                                <input type="checkbox" role="checkbox" aria-label={answerOption.answer && parse(answerOption.answer)} disabled="true" className="answerOption" />
                            </span>
                        )
                }
            };
            return returnIcon;
        }
    }
    const { items } = usePagination({
        count: totalQuestionCount,
        pageProp: questionBankVOList,
        boundaryCount: 2,
        onChange: (e) => getQuestion(e)
    });
    useEffect(() => {
        const fetchImgForCurrentQuestion = async () => {
            const currentQuestionImg = document.querySelector('img[src*="questionimages/"]');
            if (currentQuestionImg) {
                let relativeUrl = `/casebook/questionimages${currentQuestionImg.src.split('/questionimages')[1]}`;
                relativeUrl = relativeUrl.split('?')[0];
                let reqData = { "genericServiceRequestVO": { "inputBaseUrl": relativeUrl } };
                try {
                    const data = await (await post("/manageUrlService/getCDNUrl", reqData, "ENV")).json();
                    if (data.status === "true") {
                        currentQuestionImg.src = data.genericServiceResponseVO.cdnUrl;
                        currentQuestionImg.style.maxHeight = "250px";
                        currentQuestionImg.style.maxWidth = "100%";
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                } catch (error) {
                    console.error("There has been a problem with your fetch operation:", error);
                }
            }
        }
        fetchImgForCurrentQuestion();
    }, [currentQuestion])
    const handleBackToStudyCenter = (e) => {
        if (e.key === "Enter") {
            navigateToStudyDashboard(e);
        }
    }
    const handleNavigateToChapterInsights = (e) => {
        if (e.key === 'Enter') {
            navigateToChapterInsights();
        }
    }
    return (
        <React.Fragment>
            <Header userVO={userVO} bookVO={bookVO} pageName="study" ></Header>
            <StudyCenterHeader userVO={userVO} />
            <div className="col-lg-12">
                <div className="row greyDiv">
                    <div className="col-xl-8 col-lg-7 col-md-5 col-sm-12 col-xs-12 headingDiv">
                        <span className="insightProperty">{userVORole == "Professor" ? "Student Preview : " : null}{loName}</span><br />
                        <span className="insightHeading">Multiple Choice</span><br />
                        <div style={{ display: 'flex' }}>
                            <div className="studyLink cusorPointer" onClick={navigateToStudyDashboard} tabindex="0" onKeyDown={(e) => handleBackToStudyCenter(e)}> Back to Study Center </div>
                            {userVORole == "Professor" ?
                                <div style={{ display: 'contents' }}>
                                    <i className="fa fa-angle-right" aria-hidden="true" style={{ padding: '0% 1%', fontWeight: 'bold', fontSize: '14px' }}></i>
                                    <span className="studyLink cusorPointer" onClick={navigateToChapterInsights} tabIndex="0" onKeyDown={(e) => handleNavigateToChapterInsights(e)}> Chapter Insights</span>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-5 col-md-7 col-sm-12 col-xs-12" style={{ margin: 'auto' }}>
                        <ButtonToolbar aria-label="Toolbar with button groups" style={{ justifyContent: 'center' }}>
                            <ButtonGroup className="mr-2" aria-label="First group">
                                <ul className={classes.ul}>
                                    {items.map(({ page, type, selected, ...item }, index) => {
                                        let children = null;
                                        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                                            if (totalQuestionCount != "1" && parseInt(totalQuestionCount) > 6) {
                                                children = (<i style={{ margin: '15px 5px 0 0' }} className="fa fa-ellipsis-h" aria-hidden="true"></i>);
                                            }
                                        } else if (type === 'page') {
                                            if (questionBankVOList !== null && questionBankVOList !== undefined) {
                                                if (questionBankVOList[page - 1].questionResponseVO !== null && questionBankVOList[page - 1].questionResponseVO !== undefined) {
                                                    if (questionBankVOList[page - 1].questionResponseVO.status === "incorrect") {
                                                        children = (<span><button {...item} style={{ color: selected ? '#000' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox redBgColor">{page}</button> &nbsp;&nbsp; </span>)
                                                    }
                                                    else if (questionBankVOList[page - 1].questionResponseVO.status === "correct") {
                                                        children = (<span><button {...item} style={{ color: selected ? '#000' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox greenBgColor">{page}</button>&nbsp;&nbsp; </span>)
                                                    }
                                                    else if (questionBankVOList[page - 1].questionResponseVO.status === "partial") {
                                                        children = (<span><button {...item} style={{ color: selected ? '#000' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox blueBgColor">{page}</button>&nbsp;&nbsp; </span>)
                                                    }
                                                    else {
                                                        children = (<span><button {...item} style={{ color: selected ? '#007AC3' : undefined, border: selected ? '1px solid #000' : undefined }} arrayIndex={page - 1} id={"btnQuestion_" + questionBankVOList[page - 1].questionNumber} aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`} className="questionNumberBtn numberBox">{page}</button>&nbsp;&nbsp; </span>)
                                                    }
                                                }
                                            }
                                        }
                                        return <li key={index}>{children}</li>;
                                    })}
                                </ul>
                            </ButtonGroup>
                        </ButtonToolbar>
                    </div>
                </div>
                <div className="row">
                    <Spinner
                        loading={isloading}
                        imageSrc={loaderColors1}
                        overlayBackground="rgba(0,0,0,0.7)"
                        label="Loading multiple choice questions"
                    />
                    <div className="studyDiv">
                        {currentQuestion !== null ?
                            <div className="questionSection">
                                {currentQuestion.questionResponseVO ?
                                    currentQuestion.questionResponseVO.endorseQuestionFlag === "1" ?
                                        <div className="shortanswerColor">
                                            <span className="insightProperty">
                                                Your professor endorses this question.
                                            </span>
                                        </div>
                                        : null : null}
                                {
                                    (
                                        currentQuestion && currentQuestion.questionVO.studyAidVOList && !Array.isArray(currentQuestion.questionVO.studyAidVOList)
                                        && currentQuestion.questionVO.studyAidVOList.studyAidTitle && currentQuestion.questionVO.studyAidVOList.studyAidLink
                                    ) ?
                                        <span> From
                                            <span className="studyLink">
                                                &nbsp; <a href={currentQuestion.questionVO.studyAidVOList.studyAidLink} target="__blank">{currentQuestion.questionVO.studyAidVOList.studyAidTitle} </a>
                                            </span>
                                        </span> : null
                                }
                                <br /> <br />
                                <div className="insightProperty" style={{ fontFamily: "Arial" }}>
                                    {currentQuestion.questionVO !== null ? parse(currentQuestion.questionVO.questionText) : ""}
                                </div>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {currentQuestion.questionVO.answerVOList !== null ?
                                            <form>
                                                <ul style={{ listStyle: 'none', padding: '0' }}>
                                                    {currentQuestion.questionVO.answerVOList.map((answerOption, index) => (
                                                        <li>
                                                            <label style={{ float: 'left' }}>
                                                                {
                                                                    currentQuestion.questionResponseVO.status !== "not attempted" ?
                                                                        getAnswerIcon(currentQuestion.questionResponseVO.attemptedAnswerVOList, index + 1, answerOption, currentQuestion.questionVO.contentType)
                                                                        : currentQuestion.questionVO.contentType !== "Multianswer" ?
                                                                            <input type="radio" role="radio" aria-label={answerOption.answer && parse(answerOption.answer)} value={"" + (index + 1)} className="answerOption" checked={answerOptionIndex === ("" + (index + 1))}
                                                                                key={"option_" + index + "_" + currentQuestion.questionVO.questionNumber} onChange={handleChange} />
                                                                            :
                                                                            <input type="checkbox" role="checkbox" aria-label={answerOption.answer && parse(answerOption.answer)} value={"" + (index + 1)} id={'chk' + index} className="answerOption" defaultChecked={answerOptionIndex === ("" + (index + 1))}
                                                                                key={"option_" + index + "_" + currentQuestion.questionVO.questionNumber} />
                                                                }
                                                            </label>
                                                            <label htmlFor={'chk' + index} style={{ width: '85%', minHeight: '25px' }}> {String.fromCharCode(65 + index)}. &nbsp;
                                                                <span id={"answerLabel_" + (index + 1)} style={{ fontFamily: "Arial" }}>{parse(answerOption.answer.trim())}</span>
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                                {
                                                    currentQuestion.questionResponseVO.status !== "not attempted" ? null :
                                                        <Button variant="outline-secondary" className="enrollButton" onClick={submitAnswer}>Submit</Button>
                                                }
                                            </form>
                                            : null}
                                    </div>
                                </div>
                                {currentQuestion.questionResponseVO !== null ?
                                    <div className="answerRationalSection">
                                        {systemGradedValue === "incorrect" ?
                                            <div>
                                                <span className="correctAns">Correct Answer: {correctAnswers(currentQuestion.questionVO.answerVOList)}</span><br />
                                                <span className="wrongAns">Your Answer:
                                                    {Array.isArray(currentQuestion.questionResponseVO.attemptedAnswerVOList) ?
                                                        selectedOptions(currentQuestion.questionResponseVO.attemptedAnswerVOList) :
                                                        String.fromCharCode(64 +
                                                            parseInt(currentQuestion.questionResponseVO.attemptedAnswerVOList.optionNumber))}
                                                </span><br />
                                            </div>
                                            : currentQuestion.questionResponseVO.status === "correct" ?
                                                <span className="correctAns">Correct Answer:{correctAnswers(currentQuestion.questionVO.answerVOList)} </span> : null}
                                        {currentQuestion.questionResponseVO.status === "not attempted" ? null :
                                            <div className="rationSection">
                                                <br /> <span className="insightHeading">Rationale for Correct Answer</span>
                                                <br /><br />
                                                <span className="insightProperty" style={{ fontFamily: "Arial" }}>
                                                    {parse(currentQuestion.questionVO.generalFeedback)}</span>
                                                <br />
                                            </div>
                                        }
                                        <hr />
                                    </div> : null}
                                <div className="myKnowledgeSection">
                                    <div className="rightSideButtonSet">
                                        {totalQuestionCount !== currentQuestion.questionNumber ?
                                            checkans == true && (systemGradedValue == "incorrect" || systemGradedValue == "correct" || systemGradedValue == "not attempted") ?
                                                <Button variant="outline-secondary" arrayIndex={currentQuestion.questionNumber} aria-label="Next question" onClick={getQuestion} className="myKnowledgeSectionButton enrollButton">Next</Button>
                                                :
                                                <Button variant="outline-secondary" arrayIndex={currentQuestion.questionNumber} aria-label="Skip this question" onClick={getQuestion} className="myKnowledgeSectionButton studyButton nextStudy">Skip</Button>
                                            : null
                                        }&nbsp;&nbsp;
                                        <Button id="btnflag" variant="outline-secondary" aria-label={currentQuestion.questionResponseVO.flagged == 'false' ? "Flag this question for later" : "Flag this question"} aria-pressed={currentQuestion.questionResponseVO.flagged} flagValue={currentQuestion.questionResponseVO.flagged} onClick={flagQuestion} className="myKnowledgeSectionButton studyButton nextStudy">
                                            {btnFlagText}
                                        </Button>
                                    </div>
                                    <div className="leftSideButtonSet">
                                        <div className="textHead">
                                            {currentQuestion.questionResponseVO.status !== "not attempted" ? "My knowledge on this question is:" : null}
                                        </div>
                                        {currentQuestion.questionResponseVO.status !== "not attempted" ?
                                            <div className="mt-2">
                                                {correctbtn == true ?
                                                    <Button aria-selected="true" variant="outline-secondary" aria-label="My knowledge on this question is: Correct" myKnowledge="correct" onClick={updateGrade} disabled={systemGradedValue === "correct" ? false : true} className="myKnowledgeSectionButton correctprimaryactive">Correct</Button>
                                                    :
                                                    <Button aria-selected="false" variant="outline-secondary" aria-label="My knowledge on this question is: Correct" myKnowledge="correct" onClick={updateGrade} disabled={systemGradedValue === "correct" ? false : true} className="myKnowledgeSectionButton studyButton correctprimary">Correct</Button>
                                                }
                                                {incorrectbtn == true ?
                                                    <Button aria-selected="true" variant="outline-secondary"  aria-label="My knowledge on this question is: Incorrect" myKnowledge="incorrect" onClick={updateGrade} disabled={systemGradedValue === "incorrect" ? false : true} className="myKnowledgeSectionButton incorrectprimaryactive ml-3">Incorrect</Button>
                                                    :
                                                    <Button aria-selected="false" variant="outline-secondary"  aria-label="My knowledge on this question is: Incorrect" myKnowledge="incorrect" onClick={updateGrade} disabled={systemGradedValue === "incorrect" ? false : true} className="myKnowledgeSectionButton studyButton incorrectprimary ml-3">Incorrect</Button>
                                                }
                                                {practicebtn == true ?
                                                    <Button aria-selected="true" variant="outline-secondary" aria-label="My knowledge on this question is: Needs Practice" myKnowledge="partial" onClick={updateGrade} className="myKnowledgeSectionButton needsmoreactive ml-3">Needs Practice</Button>
                                                    :
                                                    <Button aria-selected="false" variant="outline-secondary" aria-label="My knowledge on this question is: Needs Practice" myKnowledge="partial" onClick={updateGrade} className="myKnowledgeSectionButton studyButton needsmore ml-3">Needs Practice</Button>
                                                }
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            </div> : null}
                        <br /><br /><br /><br />
                        <div>
                            <span className="insightHeading">
                                About the Connected eBook Study Center
                            </span>
                            <br /> <br />
                            <span className="insightProperty">
                                The content in the Study Center is selected and maintained exclusively by Aspen Publishing and a team of professor reviewers and editors, not by the authors of your book. These materials typically come from one or more of Aspen Publishing's top study aids, including Examples & Explanations, Glannon Guides, Emanuel Law Outlines, and Emanuel Law in a Flash, or may be created with assistance from AI tools. Study material sources and activity types vary depending on availability for any given chapter, topic, or course.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    )
}
export default withAuth(withRouter(StudyMCQStudent));